import { useAtomValue, useSetAtom } from "jotai";
import Script from "next/script";
import { type FunctionComponent, useCallback } from "react";

import { config } from "shared/data";

import { googleFundingChoicesAtom } from "scmp-app/components/advertisement/funding-choices/atoms";
import { appAtom } from "scmp-app/lib/app/atoms";

import { magnitePrebidJSAtom } from "./atoms";
import { useCheckGeo } from "./hooks";

export const MagniteDemandManagerScripts: FunctionComponent = () => {
  const setMagnitePrebidJSAtom = useSetAtom(magnitePrebidJSAtom);
  const { isReady: isFundingChoiceReady } = useAtomValue(googleFundingChoicesAtom);
  const { navigatorInfo } = useAtomValue(appAtom);
  const { shouldSkipMagnite } = useCheckGeo();

  const handleLoaded = useCallback(() => {
    setMagnitePrebidJSAtom({
      isReady: true,
    });
  }, [setMagnitePrebidJSAtom]);
  // Skip consent check for specific Asian markets
  const skipConsentCheck = ["AU", "HK", "ID", "IN", "MY", "PH", "SG", "VN"].includes(
    navigatorInfo?.country ?? "",
  );

  // Skip Magnite script loading if:
  // 1. Geo is in skip list (shouldSkipMagnite)
  // 2. OR region requires GDPR consent but it's not ready yet
  if (shouldSkipMagnite || (!skipConsentCheck && !isFundingChoiceReady)) {
    return null;
  }

  return (
    <Script
      id="magnite-demand-manager-script"
      onError={handleLoaded}
      onLoad={handleLoaded}
      src={config.advertisement.magniteDemandManger.scriptUrl}
      strategy="afterInteractive"
    />
  );
};

MagniteDemandManagerScripts.displayName = "MagniteDemandManagerScripts";
